<app-new-button
  [type]="'basic'"
  [svgIconPath]="icon"
  [isActive]="(isPanelOpened$ | async) && (areAllThreadsOpened$ | async)"
  [size]="'responsive'"
  [disabled]="isLoading || disabled"
  [ngbTooltip]="isOnlyIcon ? ('commenting.commentsBtn' | translate) : null"
  [placement]="'top'"
  (click)="openPanel()"
>
  @if (!isOnlyIcon) {
    {{ 'commenting.commentsBtn' | translate }}
  }

  @if (!isLoading && (overallCommentsCount$ | async); as commentsCount) {
    ({{ commentsCount }})
  }
</app-new-button>
